import React from 'react';

/**
 * Renders an email so that only the local part (name/alias) truncates with an
 * ellipsis when space runs out, while the @domain stays fully visible.
 * Short emails render in full, unchanged.
 */
export const EllipsedEmail: React.FC<{ email: string; className?: string }> = ({
  email,
  className = '',
}) => {
  const at = email.lastIndexOf('@');
  if (at === -1) {
    return (
      <span className={`truncate ${className}`} title={email}>
        {email}
      </span>
    );
  }
  return (
    <span className={`inline-flex max-w-full min-w-0 ${className}`} title={email}>
      <span className="truncate">{email.slice(0, at)}</span>
      <span className="shrink-0">{email.slice(at)}</span>
    </span>
  );
};
